// import

const RoadMap: React.FC = () => {
  return (
    <section
      className="roadmap roadmap--style1 padding-top padding-bottom"
      id="roadmap"
      // style="background-image: url(assets/images/roadmap/bg.jpg)"
    >
      <div className="container">
        <div className="section-header text-center">
          <p className="subtitle">Roadmap</p>
          <h2>How it all started</h2>
        </div>
        <div className="roadmap__wrapper">
          <div className="row gy-4 gy-md-0 gx-5">
            <div className="col-md-6 offset-md-6">
              <div
                className="roadmap__item ms-md-4 aos-init aos-animate"
                data-aos="fade-left"
                data-aos-duration="800"
              >
                <div className="roadmap__item-inner">
                  <div className="roadmap__item-content">
                    <div className="roadmap__item-header">
                      <h4>Launched Initialized</h4>
                      <p>30%</p>
                    </div>
                    <p>
                      We as founders, really wanted to focus on NFT which will open doors to a lot of opportunities for holders. Of course, a strong community is absolutely necessary, but building a solid community would be much more difficult without adding value to holders' life.
                    </p>
                  </div>
                </div>
                <span className="svg-shape">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    width="210px"
                    height="10px"
                  >
                    <path
                      fill-rule="evenodd"
                      fill-opacity="0.102"
                      d=" M5.000,-0.001 L30.000,-0.001 L25.000,9.999 L-0.000,9.999 L5.000,-0.001
                                        Z"
                    ></path>
                    <path
                      fill-rule="evenodd"
                      fill-opacity="0.302"
                      d=" M35.000,-0.001 L60.000,-0.001 L55.000,9.999 L30.000,9.999 L35.000,-0.001
                                        Z"
                    ></path>
                    <path
                      fill-rule="evenodd"
                      fill-opacity="0.502"
                      d=" M65.000,-0.001 L90.000,-0.001 L85.000,9.999 L60.000,9.999 L65.000,-0.001
                                        Z"
                    ></path>
                    <path
                      fill-rule="evenodd"
                      fill-opacity="0.702"
                      d=" M95.000,-0.001 L120.000,-0.001 L115.000,9.999 L90.000,9.999 L95.000,-0.001
                                        Z"
                    ></path>
                    <path
                      fill-rule="evenodd"
                      fill-opacity="0.8"
                      d=" M125.000,-0.001 L150.000,-0.001 L145.000,9.999 L120.000,9.999
                                        L125.000,-0.001 Z"
                    ></path>
                    <path
                      fill-rule="evenodd"
                      fill-opacity="0.902"
                      d=" M155.000,-0.001 L180.000,-0.001 L175.000,9.999 L150.000,9.999
                                        L155.000,-0.001 Z"
                    ></path>
                    <path
                      fill-rule="evenodd"
                      d=" M185.000,-0.001 L210.000,-0.001 L210.000,9.999 L180.000,9.999
                                        L185.000,-0.001 Z"
                    ></path>
                  </svg>
                </span>
              </div>
            </div>
            <div className="col-md-6">
              <div
                className="roadmap__item ms-auto me-md-4 aos-init"
                data-aos="fade-right"
                data-aos-duration="800"
              >
                <div className="roadmap__item-inner">
                  <div className="roadmap__item-content">
                    <div className="roadmap__item-header">
                      <h4>3D NFT PROJECTs</h4>
                      <p>50%</p>
                    </div>
                    <p>
                      We are going to have 4 different 3D NFT  projects which will be sold in the public market from $500, $1,000, $2,500 and $5,000 respectively.
                      You can join whitelisted users if you become a Partner with us by joining Steamitglobal family.
                    </p>
                  </div>
                </div>
                <span className="svg-shape">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    width="210px"
                    height="10px"
                  >
                    <path
                      fill-rule="evenodd"
                      fill-opacity="0.102"
                      d=" M5.000,-0.001 L30.000,-0.001 L25.000,9.999 L-0.000,9.999 L5.000,-0.001
                                                                Z"
                    ></path>
                    <path
                      fill-rule="evenodd"
                      fill-opacity="0.302"
                      d=" M35.000,-0.001 L60.000,-0.001 L55.000,9.999 L30.000,9.999 L35.000,-0.001
                                                                Z"
                    ></path>
                    <path
                      fill-rule="evenodd"
                      fill-opacity="0.502"
                      d=" M65.000,-0.001 L90.000,-0.001 L85.000,9.999 L60.000,9.999 L65.000,-0.001
                                                                Z"
                    ></path>
                    <path
                      fill-rule="evenodd"
                      fill-opacity="0.702"
                      d=" M95.000,-0.001 L120.000,-0.001 L115.000,9.999 L90.000,9.999 L95.000,-0.001
                                                                Z"
                    ></path>
                    <path
                      fill-rule="evenodd"
                      fill-opacity="0.8"
                      d=" M125.000,-0.001 L150.000,-0.001 L145.000,9.999 L120.000,9.999
                                                                L125.000,-0.001 Z"
                    ></path>
                    <path
                      fill-rule="evenodd"
                      fill-opacity="0.902"
                      d=" M155.000,-0.001 L180.000,-0.001 L175.000,9.999 L150.000,9.999
                                                                L155.000,-0.001 Z"
                    ></path>
                    <path
                      fill-rule="evenodd"
                      d=" M185.000,-0.001 L210.000,-0.001 L210.000,9.999 L180.000,9.999
                                                                L185.000,-0.001 Z"
                    ></path>
                  </svg>
                </span>
              </div>
            </div>
            <div className="col-md-6 offset-md-6">
              <div
                className="roadmap__item ms-md-4 aos-init"
                data-aos="fade-left"
                data-aos-duration="800"
              >
                <div className="roadmap__item-inner">
                  <div className="roadmap__item-content">
                    <div className="roadmap__item-header">
                      <h4>COMMUNITY BUILDING</h4>
                      <p>75%</p>
                    </div>
                    <p>
                      We are giving out 70% of funds realized to holders and partners of Steamitglobal. The major aim of Steamitglobal is to help the community financially and grow leaders globally.
                    </p>
                  </div>
                </div>
                <span className="svg-shape">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    width="210px"
                    height="10px"
                  >
                    <path
                      fill-rule="evenodd"
                      fill-opacity="0.102"
                      d=" M5.000,-0.001 L30.000,-0.001 L25.000,9.999 L-0.000,9.999 L5.000,-0.001
                                                                Z"
                    ></path>
                    <path
                      fill-rule="evenodd"
                      fill-opacity="0.302"
                      d=" M35.000,-0.001 L60.000,-0.001 L55.000,9.999 L30.000,9.999 L35.000,-0.001
                                                                Z"
                    ></path>
                    <path
                      fill-rule="evenodd"
                      fill-opacity="0.502"
                      d=" M65.000,-0.001 L90.000,-0.001 L85.000,9.999 L60.000,9.999 L65.000,-0.001
                                                                Z"
                    ></path>
                    <path
                      fill-rule="evenodd"
                      fill-opacity="0.702"
                      d=" M95.000,-0.001 L120.000,-0.001 L115.000,9.999 L90.000,9.999 L95.000,-0.001
                                                                Z"
                    ></path>
                    <path
                      fill-rule="evenodd"
                      fill-opacity="0.8"
                      d=" M125.000,-0.001 L150.000,-0.001 L145.000,9.999 L120.000,9.999
                                                                L125.000,-0.001 Z"
                    ></path>
                    <path
                      fill-rule="evenodd"
                      fill-opacity="0.902"
                      d=" M155.000,-0.001 L180.000,-0.001 L175.000,9.999 L150.000,9.999
                                                                L155.000,-0.001 Z"
                    ></path>
                    <path
                      fill-rule="evenodd"
                      d=" M185.000,-0.001 L210.000,-0.001 L210.000,9.999 L180.000,9.999
                                                                L185.000,-0.001 Z"
                    ></path>
                  </svg>
                </span>
              </div>
            </div>
            <div className="col-md-6">
              <div
                className="roadmap__item ms-auto me-md-4 aos-init"
                data-aos="fade-right"
                data-aos-duration="800"
              >
                <div className="roadmap__item-inner">
                  <div className="roadmap__item-content">
                    <div className="roadmap__item-header">
                      <h4>Launched Metaverse</h4>
                      <p>100%</p>
                    </div>
                    <p>
                      All holders of our 3D Nft will have unlimited access to all projects developed by Steamitglobal. Join our social media platforms for updates.
                    </p>
                  </div>
                </div>
                <span className="svg-shape">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    width="210px"
                    height="10px"
                  >
                    <path
                      fill-rule="evenodd"
                      fill-opacity="0.102"
                      d=" M5.000,-0.001 L30.000,-0.001 L25.000,9.999 L-0.000,9.999 L5.000,-0.001
                                                                Z"
                    ></path>
                    <path
                      fill-rule="evenodd"
                      fill-opacity="0.302"
                      d=" M35.000,-0.001 L60.000,-0.001 L55.000,9.999 L30.000,9.999 L35.000,-0.001
                                                                Z"
                    ></path>
                    <path
                      fill-rule="evenodd"
                      fill-opacity="0.502"
                      d=" M65.000,-0.001 L90.000,-0.001 L85.000,9.999 L60.000,9.999 L65.000,-0.001
                                                                Z"
                    ></path>
                    <path
                      fill-rule="evenodd"
                      fill-opacity="0.702"
                      d=" M95.000,-0.001 L120.000,-0.001 L115.000,9.999 L90.000,9.999 L95.000,-0.001
                                                                Z"
                    ></path>
                    <path
                      fill-rule="evenodd"
                      fill-opacity="0.8"
                      d=" M125.000,-0.001 L150.000,-0.001 L145.000,9.999 L120.000,9.999
                                                                L125.000,-0.001 Z"
                    ></path>
                    <path
                      fill-rule="evenodd"
                      fill-opacity="0.902"
                      d=" M155.000,-0.001 L180.000,-0.001 L175.000,9.999 L150.000,9.999
                                                                L155.000,-0.001 Z"
                    ></path>
                    <path
                      fill-rule="evenodd"
                      d=" M185.000,-0.001 L210.000,-0.001 L210.000,9.999 L180.000,9.999
                                                                L185.000,-0.001 Z"
                    ></path>
                  </svg>
                </span>
              </div>
            </div>


          </div>
        </div>
      </div>
    </section>
  );
};

export default RoadMap;
